/* eslint-disable */
// Renvoi du code de confirmation d'inscription, avec un jeton hCaptcha NEUF à chaque appel.
//
// Pourquoi ce module (24 sept. 2026) : la prod a le captcha activé sur l'authentification, et
// /auth/v1/resend y est soumis comme /signup et /token. Les trois renvois de screens-auth
// n'envoyaient AUCUN jeton → 400 captcha_failed systématique, et deux d'entre eux affichaient
// quand même « code envoyé ». Un jeton hCaptcha ne sert qu'une fois : celui de l'inscription ou
// de la connexion est déjà consommé au moment où l'on veut renvoyer le code, il en faut un neuf.
// Widget INVISIBLE : pas de case à cocher en plus ; hCaptcha n'affiche un défi que s'il doute.
import { supabase, trackSignupEvent } from "./supabase";

const SITEKEY = "82d6f3d6-3b54-4220-854e-7f663662e8fa";
let widgetId = null;

function waitForHcaptcha(timeoutMs = 6000) {
  return new Promise((resolve) => {
    if (typeof window !== "undefined" && window.hcaptcha) return resolve(true);
    const t0 = Date.now();
    const iv = setInterval(() => {
      if (window.hcaptcha) { clearInterval(iv); resolve(true); }
      else if (Date.now() - t0 > timeoutMs) { clearInterval(iv); resolve(false); }
    }, 150);
  });
}

async function freshCaptchaToken() {
  if (!(await waitForHcaptcha())) throw new Error("captcha_unavailable");
  if (widgetId === null) {
    const host = document.createElement("div");
    host.setAttribute("aria-hidden", "true");
    document.body.appendChild(host);
    widgetId = window.hcaptcha.render(host, { sitekey: SITEKEY, size: "invisible" });
  } else {
    window.hcaptcha.reset(widgetId);
  }
  const res = await window.hcaptcha.execute(widgetId, { async: true });
  return res && res.response;
}

// Retourne { ok: true } ou { ok: false, reason, message? }.
// reason : "captcha_unavailable" (script bloqué) · "captcha_failed" (défi fermé ou refusé) ·
//          "send_failed" (Supabase a refusé, message lisible dans `message`).
export async function resendSignupCode(email) {
  let token;
  try {
    token = await freshCaptchaToken();
  } catch (e) {
    const reason = String(e?.message || e) === "captcha_unavailable" ? "captcha_unavailable" : "captcha_failed";
    trackSignupEvent("resend_" + reason, null);
    return { ok: false, reason };
  }
  if (!token) {
    trackSignupEvent("resend_captcha_failed", null);
    return { ok: false, reason: "captcha_failed" };
  }
  const { error } = await supabase.auth.resend({ type: "signup", email, options: { captchaToken: token } });
  if (error) {
    // Trace anonyme du motif : un repli silencieux doit laisser une trace lisible.
    trackSignupEvent("resend_send_failed_" + (error.status || "x"), null);
    return { ok: false, reason: "send_failed", message: error.message };
  }
  return { ok: true };
}

export function resendErrorText(r, t) {
  if (r.reason === "captcha_unavailable") return t.errCaptchaBlocked;
  if (r.reason === "captcha_failed") return t.errCaptcha;
  return (t.errPrefix || "Erreur : ") + (r.message || "");
}
